import {createApp} from "vue";
import App from "./App.vue";
import {store} from "./store";
import {Translations} from "@/types";

const appElement = document.querySelector<HTMLDivElement>("[data-store-catalog]");
if (appElement) {
    const translations = JSON.parse(appElement.dataset.translations ?? '{}') as Translations;
    createApp(App, {translations: translations})
        .use(store)
        .mount(appElement);
}
